module.exports=function(scope){ return `allprojects {
    repositories {
        jcenter()

        // inform gradle where to look for zoom authentication libs
        flatDir{ dirs '../libs/' }
    }
}
`};


// WEBPACK FOOTER //
// ./src/resources/code/quickstart/android/01-gradle-manual-config.java.tpl